module.exports = __webpack_public_path__ + "img/2026-10-11a_1.efd3c5fe.jpg";